import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import line from "./line";

const getDefaultSelectedTicketClassRule = () => {
  return {};
};

export default {
  state: () => ({
    pricings: [],
    pricingDetails: [],
    selectedPricing: {},
    clickedPricingDescribe: false,
    ticketClassRules: [],
    selectedTicketClassRule: getDefaultSelectedTicketClassRule(),
    distanceBasedPricings: [],
    pricingPeriods: [],
  }),

  mutations: {
    setSelectedPricing(state, pricing) {
      Vue.set(state, "selectedPricing", pricing);
    },
    setPricings(state, pricings) {
      Vue.set(state, "pricings", pricings);
    },
    setPricingDetails(state, pricingDetails) {
      Vue.set(state, "pricingDetails", pricingDetails);
    },
    setClickedPricingDescribe(state, clickedPricingDescribe) {
      Vue.set(state, "clickedPricingDescribe", clickedPricingDescribe);
    },
    setTicketClassRules(state, ticketClassRules) {
      Vue.set(state, "ticketClassRules", ticketClassRules);
    },
    setSelectedTicketClassRule(state, selectedTicketClassRule) {
      Vue.set(state, "selectedTicketClassRule", selectedTicketClassRule);
    },
    setDistanceBasedPricings(state, distanceBasedPricings) {
      Vue.set(state, "distanceBasedPricings", distanceBasedPricings);
    },
    setPricingPeriods(state, pricingPeriods) {
      Vue.set(state, "pricingPeriods", pricingPeriods);
    },
    setDefaultSelectedTicketClassRule(state) {
      Vue.set(state, "selectedTicketClassRule", getDefaultSelectedTicketClassRule());
    },
    setDefaultPricingModule(state) {
      Vue.set(state, "pricings", []);
      Vue.set(state, "pricingDetails", []);
      Vue.set(state, "selectedPricing", {});
      Vue.set(state, "clickedPricingDescribe", false);
      Vue.set(state, "ticketClassRules", []);
      Vue.set(state, "selectedTicketClassRule", getDefaultSelectedTicketClassRule());
      Vue.set(state, "distanceBasedPricings", []);
      Vue.set(state, "pricingPeriods", []);
    },
  },
  actions: {
    loadPricings: (context) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/pricing/load-pricings")
        .then((response) => {
          // context.commit("setPricings", response.data);
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadPricing: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/entity/" + request.id).then((response) => {
        context.commit("setSelectedPricing", response.data);
        return response.data;
      });
    },
    loadDraftPricing: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/entity/draft/" + intentId).then((response) => {
        context.commit("setSelectedPricing", response.data);
        return response.data;
      });
    },
    loadPricingByLineId: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/line/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    loadPricingDetails: (context, pricing) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/pricing/load-pricing-details/" + pricing.id)
        .then((response) => {
          // context.commit("setPricingDetails", response.data);
          //console.log("pricing details");
          //console.log(response.data);
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    createPricing: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/pricing/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadPricingsMC: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadPublishedPricing: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/entity/published").then((response) => {
        // context.commit("setPricings", response.data);
        return response.data;
      });
    },
    loadPricingHistory: (context, request) => {
      return axios.post(context.getters.getServiceUrl + "/pricing/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedPricingHistory: (context, pricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/history/" + pricing.id, {}).then((response) => {
        return response.data;
      });
    },

    priceDefinition: (context, pricing) => {
      return axios.get(context.getters.getServiceUrl + "/pricing/history/" + pricing.id, {}).then((response) => {
        return response.data;
      });
    },
    //TODO
    searchPricingByStationId: (context, request) => {
      return axios.post(context.getters.getServiceUrl + "/pricing/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deletePricing: (context, pricing) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/pricing/entity/" + pricing.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          pricing.intents = intents;
          pricing.intentId = response.data.id;
          return pricing;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftPricing: (context, pricing) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/pricing/draft/" + pricing.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishPricing: (context, pricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/publish/" + pricing.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectPricing: (context, pricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/reject/" + pricing.intentId).then((response) => {
        helper.recallOrRejectEntity(pricing, "pricing");
        return response.data;
      });
    },
    sendToApprovalPricing: (context, pricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/sendToApproval/" + pricing.intentId).then((response) => {
        if (pricing.intents[0].type === "CREATE_PRICING") {
          pricing.intents[0].status = "WAITING_APPROVAL";
        } else if (pricing.intents[0].type === "UPDATE_PRICING") {
          pricing.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallPricing: (context, pricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/recall/" + pricing.intentId).then((response) => {
        helper.recallOrRejectEntity(pricing, "pricing");
        return response.data;
      });
    },

    cancelPricing: (context, pricing) => {
      return axios.get(context.getters.getMcServiceUrl + "/pricing/cancel/" + pricing.intentId).then((response) => {
        return response.data;
      });
    },

    // ticketRules start

    loadTicketClassRules: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/ticket-class-rules/entity").then((response) => {
        context.commit("setTicketClassRules", response.data);
        return response.data;
      });
    },
    loadTicketClassRuleDetails: (context, id) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/ticket-class-rules/load-ticket-class-rule-details/" + id)
        .then((response) => {
          context.commit("setSelectedTicketClassRule", response.data);
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createTicketClassRules: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/ticket-class-rules/entity", request, {}).then((response) => {
        return response;
      });
    },
    loadPublishedTicketClassRules: (context) => {
      return axios.get(context.getters.getServiceUrl + "/ticket-class-rules/published").then((response) => {
        context.commit("setTicketClassRules", response.data);
        return response.data;
      });
    },
    loadTicketClassRulesHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/ticket-class-rules/history/" + request.id).then((response) => {
        return response.data;
      });
    },

    deleteTicketClassRule: (context, ticketClassRule) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/ticket-class-rules/entity/" + ticketClassRule.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          ticketClassRule.intents = intents;
          ticketClassRule.intentId = response.data.id;
          return ticketClassRule;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishTicketClassRule: (context, ticketClassRule) => {
      return axios.get(context.getters.getMcServiceUrl + "/ticket-class-rules/publish/" + ticketClassRule.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectTicketClassRule: (context, ticketClassRule) => {
      return axios.get(context.getters.getMcServiceUrl + "/ticket-class-rules/reject/" + ticketClassRule.intentId).then((response) => {
        helper.recallOrRejectEntity(ticketClassRule, "pricing");
        return response.data;
      });
    },
    sendToApprovalTicketClassRule: (context, ticketClassRule) => {
      return axios.get(context.getters.getMcServiceUrl + "/ticket-class-rules/sendToApproval/" + ticketClassRule.intentId).then((response) => {
        if (ticketClassRule.intents[0].type === "CREATE_TICKET-CLASS-RULES") {
          ticketClassRule.intents[0].status = "WAITING_APPROVAL";
        } else if (ticketClassRule.intents[0].type === "UPDATE_TICKET-CLASS-RULES") {
          ticketClassRule.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallTicketClassRule: (context, ticketClassRule) => {
      return axios.get(context.getters.getMcServiceUrl + "/ticket-class-rules/recall/" + ticketClassRule.intentId).then((response) => {
        helper.recallOrRejectEntity(ticketClassRule, "ticket-class-rules");
        return response.data;
      });
    },

    cancelTicketClassRule: (context, ticketClassRule) => {
      return axios.get(context.getters.getMcServiceUrl + "/ticket-class-rules/cancel/" + ticketClassRule.intentId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getPricings: (state) => {
      return state.pricings;
    },
    getPricingDetails: (state) => {
      return state.pricingDetails;
    },

    getSelectedPricing: (state) => {
      return state.selectedPricing;
    },
    getPublishedPricing: (state) => {
      return state.pricings.filter((entity) => {
        return entity.intentId === 0;
      });
    },
    getClickedPricingDescribe: (state) => {
      return state.clickedPricingDescribe;
    },
    getTicketClassRules: (state) => {
      return state.ticketClassRules;
    },
    getSelectedTicketClassRule: (state) => {
      return state.selectedTicketClassRule;
    },
    getDistanceBasedPricings: (state) => {
      return state.distanceBasedPricings;
    },
    getPricingPeriods: (state) => {
      return state.selectedTicketClassRule;
    },
  },
};
